import {COLORS} from '@/styles/colors';

export const CheckSmall = ({
  size = 24,
  backgroundColor = COLORS.BACKGROUND_ON_SECONDARY_CONTAINER,
  fillColor = COLORS.ON_SURFACE_VARIANT,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_check_small"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect
          width="24"
          height="24"
          fill={backgroundColor}
        />
      </mask>
      <g mask="url(#mask0_check_small)">
        <path
          d="M9.99997 13.4028L15.8042 7.59826C16.0196 7.3831 16.2848 7.27551 16.6 7.27551C16.9151 7.27551 17.1804 7.3831 17.3957 7.59826C17.6109 7.8136 17.7185 8.07985 17.7185 8.39701C17.7185 8.71418 17.6109 8.98043 17.3957 9.19576L10.8017 15.7958C10.5737 16.0236 10.3065 16.1375 9.99997 16.1375C9.69347 16.1375 9.42622 16.0236 9.19822 15.7958L6.59822 13.1958C6.38305 12.9804 6.27647 12.7142 6.27847 12.397C6.28047 12.0798 6.38905 11.8136 6.60422 11.5983C6.81955 11.3831 7.0858 11.2755 7.40297 11.2755C7.72014 11.2755 7.98639 11.3831 8.20172 11.5983L9.99997 13.4028Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};
